export const PreviewMessageType = {
  AUTH: 'AUTH',
  PREVIEW: 'PREVIEW',
  PROPS_UPDATED: 'PROPS_UPDATED',
  AUTO_SCROLL: 'AUTO_SCROLL',
  COLOR_PREVIEW: 'COLOR_PREVIEW',
  LOGO_PREVIEW: 'LOGO_PREVIEW',
  THEME_OVERRIDE: 'THEME_OVERRIDE',
  SECTION_DATA: 'SECTION_DATA',
} as const;

type PreviewMessage =
  | {
      type: typeof PreviewMessageType.AUTH;
      payload: { userId: string; expiresAt: number; signature: string };
    }
  | {
      type: typeof PreviewMessageType.PREVIEW;
      payload: {
        plusWebsiteId: string;
        pageId: string;
        sectionId?: string;
        sectionType?: string;
        globalSectionIds?: { header?: string; footer?: string };
        scrollToSectionId?: string;
      };
    }
  | { type: typeof PreviewMessageType.PROPS_UPDATED }
  | { type: typeof PreviewMessageType.AUTO_SCROLL }
  | {
      type: typeof PreviewMessageType.COLOR_PREVIEW;
      payload: { primaryColor: string };
    }
  | {
      type: typeof PreviewMessageType.LOGO_PREVIEW;
      payload: { logoUrl: string };
    }
  | {
      type: typeof PreviewMessageType.THEME_OVERRIDE;
      payload: { primaryColor?: string; logoUrl?: string };
    }
  | {
      type: typeof PreviewMessageType.SECTION_DATA;
      payload: { sectionId: string; sectionType?: string; data: Record<string, unknown> };
    };

export function sendPreviewMessage(
  iframe: HTMLIFrameElement | null,
  message: PreviewMessage,
  targetOrigin = '*'
): void {
  if (!iframe?.contentWindow) return;
  const origin = window.location.origin.startsWith('http://localhost:') ? '*' : targetOrigin;
  iframe.contentWindow.postMessage(message, origin);
}

const BROADCAST_CHANNEL_NAME = 'plus-websites-preview';

export function broadcastPropsUpdated(): void {
  const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
  channel.postMessage({ type: PreviewMessageType.PROPS_UPDATED });
  channel.close();
}

export function onBroadcastPropsUpdated(callback: () => void): () => void {
  const channel = new BroadcastChannel(BROADCAST_CHANNEL_NAME);
  channel.onmessage = (event) => {
    if (event.data?.type === PreviewMessageType.PROPS_UPDATED) {
      callback();
    }
  };
  return () => channel.close();
}
